export default __webpack_public_path__ + "4381bda63fe08272ab9b28951427ad1f.png";